// extracted by mini-css-extract-plugin
module.exports = {"button":"SportTicketActionScommetti_button__T7dyQ","disable":"SportTicketActionScommetti_disable__Kbvt4"};